<script>
	// Stores
	import ClassificationBetTypeStore from '@/Stores/Racing/ClassificationBetTypeStore.js';
	// Components
	import Icon from '@/Components/Icon.svelte';

	export let _selectedBetTypes;
	export let product;
	export let betType;
	export let bonusAllowlist;
	export let showClassificationDefaults;

	$: (bonusPercentage || !bonusPercentage) && updateBonus();

	let bonusPercentage =
		_selectedBetTypes
			.where('product.id', parseInt(product.id))
			.where('bet_type.id', parseInt(betType.id))
			.pluck('bonus_percentage')
			.first() || 0;

	function updateBonus() {
		_selectedBetTypes = _selectedBetTypes.map((item) => {
			if (item.product.id === parseInt(product.id) && item.bet_type.id === parseInt(betType.id)) {
				item.bonus_percentage = bonusPercentage;
			}
			return item;
		});
	}

	function clickProductBetType(productId, betTypeId) {
		if (productBetTypeExists(productId, betTypeId)) {
			_selectedBetTypes = _selectedBetTypes.reject((item) => {
				if (item.product.id === productId && item.bet_type.id === betTypeId) {
					return true;
				}
			});
		} else {
			_selectedBetTypes.push({
				bet_type: { id: betTypeId },
				product: { id: productId },
				bonus_percentage: bonusPercentage
			});
			// this triggers reactivity https://svelte.dev/tutorial/updating-arrays-and-objects
			_selectedBetTypes = _selectedBetTypes;
		}
	}

	function productBetTypeExists(productId, betTypeId) {
		return !!_selectedBetTypes.where('product.id', productId).where('bet_type.id', betTypeId).count();
	}

	function isClassificationDefault(productId, betTypeId) {
		return !!(
			showClassificationDefaults &&
			$ClassificationBetTypeStore
				.where('product.id', parseInt(productId))
				.where('bet_type.id', parseInt(betTypeId))
				.count()
		);
	}
</script>

<td
	on:click={() => clickProductBetType(parseInt(product.id), parseInt(betType.id))}
	class="px-6 py-4 font-semibold text-center border-l hover:bg-gray-100"
>
	{#if _selectedBetTypes.where('product.id', parseInt(product.id)).where('bet_type.id', parseInt(betType.id)).count()}
		<Icon
			name="tick-box"
			classes="w-6 mx-auto {_selectedBetTypes && isClassificationDefault(product.id, betType.id)
				? 'text-green-500'
				: ''}"
		/>
		{#if bonusAllowlist.products.indexOf(parseInt(product.id)) >= 0 && bonusAllowlist.betTypes.indexOf(parseInt(betType.id)) >= 0}
			<div class="flex items-center justify-center mt-1" on:click|stopPropagation>
				<div>+</div>
				<div class="border-b border-black">
					<input type="number" min="0" max="50" step="0.5" bind:value={bonusPercentage} class="w-6 text-center" />
				</div>
				<div>%</div>
			</div>
		{/if}
	{:else}
		<Icon
			name="box"
			classes="w-6 mx-auto {_selectedBetTypes && isClassificationDefault(product.id, betType.id)
				? 'text-green-500'
				: ''}"
		/>
	{/if}
</td>
